import React, { useState, useEffect, useRef } from 'react';
import {Link} from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import {Pagination, Autoplay} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';

function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);

        // tisztítás
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return width;
}

function Home() {
    document.title = "Tető- és térkőmosás"

    const width = useWindowWidth();

    const services = [
        {
            id: "roof",
            title: "Tető mosása",
            description: "Magasnyomású, de kíméletes technológiával megtisztítjuk a tetőt, hogy újra biztonságos és esztétikus legyen, miközben meghosszabbítjuk az élettartamát is.",
        },
        {
            id: "paving_stone",
            title: "Térkő & kerti burkolatok mosása",
            description: "Precíz, környezetbarát tisztítással eltávolítjuk a mohát, olajfoltokat és elszíneződéseket, hogy újra olyan legyen, minth újkorában.",
        },
        {
            id: "solar_panel",
            title: "Napelem tisztítása",
            description: "Speciális, karcmentes technológiával tisztítjuk meg a paneleket, hogy újra maximális hatékonysággal termeljenek — biztonságosan, vegyszermentesen, a garancia megtartásával.",
        },
        {
            id: "gravestone",
            title: "Sírkő tisztítása",
            description: "Szakértő tisztítással eltávolítjuk a mohát, zuzmót és elszíneződéseket, hogy az emlékhely méltó és gondozott maradjon — kíméletesen, a kő anyagának megóvásával.",
        }
    ]

    const prices = [
        {
            id: "roof",
            type: "Tetőmosás",
            prices: [
                {
                    name: "Alapár",
                    price: "1100Ft/m²"
                },
                {
                    name: "Kedvezményes ár (80m² felett)",
                    price: "800Ft/m²"
                }
            ]
        },
        {
            id: "paving_stone",
            type: "Térkőmosás",
            prices: [
                {
                    name: "Térkő mosása 120m² felett",
                    price: "500Ft/m²"
                },
                {
                    name: "Térkő mosása 90 - 120m²",
                    price: "600Ft/m²"
                },
                {
                    name: "Térkő mosása 60 - 90m²",
                    price: "700Ft/m²"
                },
                {
                    name: "Térkő mosása 40 - 60m²",
                    price: "800Ft/m²"
                },
                {
                    name: "Térkő mosása 40m² alatt",
                    price: "30.000Ft"
                },
            ]
        },
        {
            id: "solar_panel",
            type: "Napelemtisztítás",
            prices: [
                {
                    name: "Napelem tisztítása 1-15 panel",
                    price: "15.000Ft"
                },
                {
                    name: "Napelem tisztítása 16-30 panel",
                    price: "25.000Ft"
                },
                {
                    name: "Napelem tisztítása 31-50 panel",
                    price: "35.000Ft"
                },
            ]
        },
        {
            id: "gravestone",
            type: "Sírkőmosás",
            prices: [
                {
                    name: "Kis méretű",
                    price: "35.000Ft"
                },
                {
                    name: "Nagy méretű",
                    price: "50.000Ft"
                },
            ]
        }
    ]

    const defaultForm = {
        firstname: "",
        lastname: "",
        email: "",
        message: "",
        phoneNumber: "",
        confirm: false
    }

    const [form, setForm] = useState(defaultForm)

    const [message, setMessage] = useState({
        message: "",
        type: "",
        show: false,
        id: 0,
        remove: true
    })

    const handleFormChange = (fieldName) => (e) => {
        if (fieldName === "confirm") {
            setForm(prevState => ({
                ...prevState,
                confirm: e.target.checked
            }))
        } else {
            setForm(prevState => ({
                ...prevState,
                [fieldName]: e.target.value
            }))
        }
    }

    const [sending, setSending] = useState(false)

    const useAutoHideMessage = (message, setMessage, delay = 3000) =>  {
        const timeoutRef = useRef(null);

        useEffect(() => {
            if (!message || !message.message) return;

            // Töröljük a korábbi timeoutot, ha van
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // Új timeout létrehozása
            timeoutRef.current = setTimeout(() => {
                setMessage(prev => prev ? { ...prev, show: false } : null);
                timeoutRef.current = null;
                setTimeout(() => {
                    setMessage(prev => prev ? { ...prev, remove: true } : null);
                }, 100)
            }, delay);

            // Cleanup: ha a komponens unmountol vagy message változik
            return () => {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            };
        }, [message?.id, setMessage, delay]);
    }

    useAutoHideMessage(message, setMessage);

    const setMessageToShow = (message) => {
        setMessage((prevState) => {
            const newState = { ...prevState };
            newState.remove = false;
            return newState;
        });
        setTimeout(() => {
            setMessage(message)
        })

    }

    const sendMail = () => {
        if (sending) return;
        setSending(true);

        fetch('https://tetoesterkomosas.hu/send_email.php', {
            method: 'POST',
            body: JSON.stringify(form),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async response => {
            if (response.ok) {
                return response.text();
            } else {
                const errorText = await response.text();
                throw new Error(errorText || 'Nem várt hiba történt.');
            }
        }).then(() => {
            setMessageToShow({id: Math.random(), message: "Email sikeresen elküldve", type: "success", show: true})
            setForm(defaultForm);
        }).catch(error => {
            setMessage({id: Math.random(), message: "Hiba az üzenet küldése közben: " + error.message, type: "error", show: true, remove: false});
        }).finally(() => {
            setSending(false);
        });
    };


    return <div className={"home-content"}>
        <div id={"home"} className={"hero-container"}>
            <div className={"content"}>
                <div className={"message-container" + (message?.show ? " show": "") + (message?.type === "error" ? " error" : "") + (message?.remove ? " remove" : "")}>{message?.message}</div>
                <div className={"left"}>
                    <div className={"service-provider title"}>Tisztaság, ami látszik. Gondoskodás, ami tartós!</div>
                    <div className={"description"}>
                        <p>Szakértő csapatunk professzionális eszközökkel tisztítja meg <span>tetődet</span>, <span>térkövedet</span>, <span>napelemeidet</span> vagy akár a <span>sírköveidet</span> is.</p>
                        <br/>
                        <p><span>Szabolcs-Szatmár-Bereg</span>, <span>Borsod-Abaúj-Zemplén</span> és <span>Hajdú-Bihar</span> vármegyében dolgozunk, hogy házad, udvarod és sírköveid ismét régi fényükben tündököljenek — gyorsan, biztonságosan, precízen.</p>
                    </div>
                    <div className={"image"}/>
                    <div className={"actions"}>
                        <Link to={{pathname: "/", hash: "#form"}}>Ingyenes árajánlat</Link>
                    </div>
                </div>
                <div className={"right"}/>
            </div>
            <div className={"services-content"}>
                <h2 className={"services title"}>Szolgáltatásaink</h2>
                <div className={"services-description"}>Teljeskörű megoldások tetőre és kültéri burkolatokra</div>
                <div className={"services-container"}>
                    {services.map((service, index) => {
                        return <div className={"service"} key={"service_index_" + index}>
                            <div className={"icon " + service.id}/>
                            <div className={"title"}>{service.title}</div>
                            <div className={"description"}>{service.description}</div>
                        </div>
                    })}
                </div>
                <div className={"slogan"}>Mert mi nem csak tisztítunk, hanem új életet is adunk a felületeidnek!</div>
            </div>
        </div>
        <div id={"about"} className={"about-container"}>
            <h2 className={"title"}>Rólunk</h2>
            <div className={"content"}>
                <div className={"description"}>
                    <div className={"title"}>Legfontosabb tudnivalók rólunk és a szolgáltatásainkról</div>
                    <p>Vállalkozásunk ugyan frissen indult, de a mögötte álló szakértelem és tapasztalat évekre nyúlik vissza. Célunk, hogy bebizonyítsuk: az új név mögött is profi munka és megbízhatóság áll. Minden munkánkat maximális odafigyeléssel, modern eszközökkel és környezetbarát megoldásokkal végezzük, mert hisszük, hogy a tisztaság és a minőség kéz a kézben jár.</p>
                    <div className={"images"}>
                        <div className={"image first"}/>
                        <div className={"image second"}/>
                    </div>
                    <p>Szolgáltatásaink során korszerű, <b>professzionális magasnyomású berendezéseket</b> és <b>kíméletes</b>, de <b>hatékony tisztítószereket</b> alkalmazunk, hogy minden felület újjáéledjen anélkül, hogy károsodna. A tetők és térkövek esetében különböző nyomásfokozatokat és speciális fúvókákat használunk, igazodva az adott anyaghoz és szennyeződéshez. Napelemek tisztításánál vegyszermentes, ioncserélt vízzel dolgozunk, így elkerüljük a vízkő- vagy csíkképződést. A sírkőápolás során finom technikákat és alacsony nyomású megoldásokat alkalmazunk, hogy a feliratok és a kőfelület épségben maradjon. Célunk, hogy minden munkánk <b>tartós</b> és <b>látványos</b> eredményt hozzon.</p>
                    <div className={"image"}/>
                    <p>Ügyfeleink elégedettsége a <b>legfontosabb számunkra</b>, ezért addig nem nyugszunk, amíg a végeredmény tökéletes nem lesz. Legyen szó tetőről, térkőről, napelemről vagy sírkőről – mi gondoskodunk róla, hogy minden újra ragyogjon.</p>
                </div>
                <div className={"images-container"}>
                    <div className={"image first"}/>
                    <div className={"image second"}/>
                    <div className={"image third"}/>
                </div>
            </div>
        </div>
        <div id={"price"} className={"prices-container"}>
            <div className={"content"}>
                <h2 className={"title"}>Áraink</h2>
                <div className={"description"}>Árainkat úgy alakítottuk ki, hogy mindig a legjobb ár-érték arányt kínáljuk ügyfeleinknek.</div>
                <div className={"tables-container"}>
                    {prices.map((price, index) => {
                        return <table className={price.id} key={"table_index_" + index}>
                            <thead>
                            <tr>
                                <th>{price.type}</th>
                                <th>Ár</th>
                            </tr>
                            </thead>
                            <tbody>
                            {price.prices.map((p, i) => {
                                return <tr key={"table_index_" + index + "_row_index_" + i}>
                                    <td>{p.name}</td>
                                    <td>{p.price}</td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    })}
                </div>
            </div>
        </div>
        <div id={"references"} className={"references-container"}>
            <h2 className={"title"}>Munkáink</h2>
            <div className={"description"}>
                <p>Nézd meg néhány korábbi munkánkat!</p>
                <p>Legyen szó tető-, térkő-, napelem- vagy sírkőmosásról, minden felületet úgy tisztítunk, mintha a sajátunk lenne.</p>
            </div>
            <Swiper
                slidesPerView={width < 700 ? 1 : 2}
                spaceBetween={20}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false
                }}
                pagination={{
                    clickable: true,

                }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide className={"reference first"}/>
                <SwiperSlide className={"reference second"}/>
                <SwiperSlide className={"reference third"}/>
                <SwiperSlide className={"reference fourth"}/>
                <SwiperSlide className={"reference fifth"}/>
                <SwiperSlide className={"reference sixth"}/>
                <SwiperSlide className={"reference seventh"}/>
            </Swiper>
        </div>
        <div id={"contact"} className={"contact-container"}>
            <div className={"content"}>
                <h2 className={"title"}>Kapcsolat</h2>
                <div className={"description"}>Akár kérdésed van, akár árajánlatot szeretnél kérni, mi mindig elérhetőek vagyunk — keress minket bizalommal!</div>
                <div className={"section"}>
                    <div id={"form"} className={"form-container"}>
                        <div className={"title"}>Érdekel, mennyibe kerülne?</div>
                        <div className={"description"}>Küldd el pár adatodat, és rövid időn belül személyre szabott, ingyenes árajánlatot kapsz tőlünk — minden kötelezettség nélkül.</div>
                        <div className={"block last-name"}>
                            <label className={"required"}>Vezetéknév</label>
                            <input value={form.lastname} onChange={handleFormChange("lastname")}/>
                        </div>
                        <div className={"block first-name"}>
                            <label className={"required"}>Keresztnév</label>
                            <input value={form.firstname} onChange={handleFormChange("firstname")}/>
                        </div>
                        <div className={"block first-email"}>
                            <label className={"required"}>E-mail cím</label>
                            <input type={"email"} value={form.email} onChange={handleFormChange("email")}/>
                        </div>
                        <div className={"block phone-number"}>
                            <label>Telefonszám</label>
                            <input value={form.phoneNumber} onChange={handleFormChange("phoneNumber")}/>
                        </div>
                        <div className={"block message"}>
                            <label className={"required"}>Üzenet</label>
                            <textarea value={form.message} onChange={handleFormChange("message")}/>
                        </div>
                        <div className={"approval-container"}>
                            <input id={"adatvedelmi"} checked={form.confirm} type={"checkbox"} onChange={handleFormChange("confirm")}/>
                            <label htmlFor={"adatvedelmi"}>Elfogadom az <Link to={"/tajekoztato/adatkezelesi"}>Adatkezelési tájékoztatót</Link></label>
                        </div>
                        <div className={"action"}>
                            <button onClick={sendMail} disabled={form.firstname === "" || form.lastname === "" || form.email === "" || form.message === "" || !form.confirm || sending} className={"focus"}>Küldés</button>
                        </div>
                    </div>
                    <div className={"additional-info"}>
                        <a href={"tel:+36304809842"} className={"block"}>
                            <div className={"description"}>Hívj minket telefonon!</div>
                            <div className={"line"}/>
                            <div className={"text-container"}>
                                <div className={"icon phone"}/>
                                <div className={"text"}>+36 30 480 9842</div>
                            </div>
                        </a>
                        <a href={"mailto:info@tetoesterkomosas.hu"} className={"block"}>
                            <div className={"description"}>Írj nekünk e-mailt!</div>
                            <div className={"line"}/>
                            <div className={"text-container"}>
                                <div className={"icon email"}/>
                                <div className={"text"}>info@tetoesterkomosas.hu</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Home;